<div class="page-layout carded left-sidenav toolbar-fixed-layout">
  <div class="toolbar second-level-toolbar flex flex-row justify-between items-center">
    <div class="grid-toolbar-buttons-group-container w-p-100 flex flex-col justify-center items-start">
      <particle-breadcrumbs [breadcrumbs]="breadcrumbs" [iconClass]="'fas fa-briefcase'"></particle-breadcrumbs>
    </div>

  </div>


  <div class="search-bar flex flex-row justify-start items-center">
    <form class="search-form" [formGroup]="inputForm">
      <mat-form-field appearance="outline" style="margin-bottom: 0px!important;flex:0 0 560px">
        <mat-label>Search</mat-label>
        <input formControlName="value" matInput
               particleAnalytics
               analyticsCategory="string-input-dialog-box">
      </mat-form-field>
    </form>
  </div>


  <div *ngIf="otherVersions && otherVersions.length > 0"
       class="toolbar second-level-toolbar flex flex-col justify-end items-center">
    <div class=" other-version grid-toolbar-buttons-group-container flex flex-col justify-center items-start">
      <button mat-button class="submit-changes" (click)="otherVersionDisplay()">
        <i class="fas fa-database"></i>
        Other versions
        <i class="fas fa-caret-down"></i>
      </button>

      <div class="popover-container" *ngIf="otherVersionsContentViewEnable">
        <div class="flex flex-col">
          <div class="header flex flex-row justify-between items-center">
            <h1>Other Versions</h1>
            <a (click)="otherVersionDisplay()"><i class="far fa-times-circle"></i></a>
          </div>
          <ul>
            <li *ngFor="let file of otherVersions">
              <a (click)="showPdf(file)">
                <span *ngIf="file.title">{{file.title}}</span>
                <span *ngIf="file.language"> - {{file.language}}</span>
                <span *ngIf="file.format"> - {{file.format}}</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <mat-sidenav-container>
    <!-- CENTER -->
    <div class="center">
      <!-- CONTENT CARD -->

      <div class="content-card mat-white-bg">

        <div class="content pos-relative m-lr-30 m-b-30 m-t-20 flex flex-col">
          <div class="keno-grid-container">
            <particle-virtual-grid [sourceKey]="sourceKey"
                                   [invalidateSubject]="invalidateSubject"
                                   sortFieldKey="Title"
                                   [pageSize]="200"
                                   (valueChanged)="onGridCellValueChange($event)">
            </particle-virtual-grid>
          </div>
        </div>
      </div>
    </div>
  </mat-sidenav-container>
</div>

